<div class="container-xxl flex-grow-1 container-p">
  <div class="row">
    <div class="col-12 col-xxl-3 col-xl-6 col-md-6 mb-3 animate__animated animate__fadeInDown animate__delay-1-2s"
    >
      <div class="card h-100">
        <div class="card-body text-center">
          <div class="row">
            <div class="col-3">
              <div class="avatar new-avatar mx-auto mb-2">
                <span class="avatar-initial rounded-circle bg-label-buy-color">
                  <i class="fa-solid fa-cart-plus"></i>
                </span>
              </div>
            </div>
            <div class="col-9 text-start">
              <span class="d-block new-title text-nowrap pt-1">
                {{ "Buy" | translate }}
              </span>
            </div>
          </div>
          <h2 class="mb-n3">
            {{ dashboardData?.buyPrice | dataType : "price" }}
          </h2>
        </div>
      </div>
    </div>
    <div class="col-12 col-xxl-3 col-xl-6 col-md-6 mb-3 animate__animated animate__fadeInDown animate__delay-1-6s"
    >
      <div class="card h-100">
        <div class="card-body text-center">
          <div class="row">
            <div class="col-3">
              <div class="avatar new-avatar mx-auto mb-2">
                <span class="avatar-initial rounded-circle bg-label-sale-color">
                  <i class="fas fa-shopping-cart"></i>
                </span>
              </div>
            </div>
            <div class="col-9 text-start">
              <span class="d-block new-title text-nowrap pt-1">
                {{ "Sale" | translate }}
              </span>
            </div>
          </div>
          <h2 class="mb-n3">
            {{ dashboardData?.salePrice | dataType : "price" }}
          </h2>
        </div>
      </div>
    </div>
    <div class="col-12 col-xxl-3 col-xl-6 col-md-6 mb-3 animate__animated animate__fadeInDown animate__delay-2-0s"
    >
      <div class="card h-100">
        <div class="card-body text-center">
          <div class="row">
            <div class="col-3">
              <div class="avatar new-avatar mx-auto mb-2">
                <span
                  class="avatar-initial rounded-circle bg-label-check-color"
                >
                  <i class="fa-solid fa-money-check-dollar"></i>
                </span>
              </div>
            </div>
            <div class="col-9 text-start">
              <span class="d-block new-title text-nowrap pt-1">
                {{ "Check" | translate }}
              </span>
            </div>
          </div>
          <h2 class="mb-n3">
            {{ dashboardData?.todayCheck | dataType : "price" }}
          </h2>
        </div>
      </div>
    </div>
    <div class="col-12 col-xxl-3 col-xl-6 col-md-6 mb-3 animate__animated animate__fadeInDown animate__delay-2-4s"
    >
      <div class="card h-100">
        <div class="card-body text-center">
          <div class="row">
            <div class="col-3">
              <div class="avatar new-avatar mx-auto mb-2">
                <span
                  class="avatar-initial rounded-circle bg-label-payment-color"
                >
                  <i class="fas fa-pager"></i>
                </span>
              </div>
            </div>
            <div class="col-9 text-start">
              <span class="d-block new-title text-nowrap pt-1">
                {{ "Payment" | translate }}
              </span>
            </div>
          </div>
          <h2 class="mb-n3">
            {{ dashboardData?.todayPayment | dataType : "price" }}
          </h2>
        </div>
      </div>
    </div>
    <div class="col-12 col-xxl-3 col-xl-6 col-md-6 mb-3 animate__animated animate__fadeInLeft animate__delay-4-0s">
      <div class="card">
        <div class="card-body text-center">
          <i class="mb-3 bx-md fa-solid fa-cart-plus"></i>
          <h5>{{ "Buy" | translate }}</h5>
          <p>{{ "BuyDescription" | translate }}</p>
          <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#pricingModal" [routerLink]="['/Buy']">
            {{ "GoToBuy" | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="col-12 col-xxl-3 col-xl-6 col-md-6 col-md-6 mb-3 animate__animated animate__fadeInLeft animate__delay-3-6s">
      <div class="card">
        <div class="card-body text-center">
          <i class="mb-3 bx-md fas fa-shopping-cart"></i>
          <h5>{{ "Sale" | translate }}</h5>
          <p>{{ "SaleDescription" | translate }}</p>
          <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#pricingModal" [routerLink]="['/Sale']">
            {{ "GoToSale" | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="col-12 col-xxl-3 col-xl-6 col-md-6 mb-3 animate__animated animate__fadeInLeft animate__delay-3-2s">
      <div class="card">
        <div class="card-body text-center">
          <i class="mb-3 bx-md fas fa-shopping-cart"></i>
          <h5>{{ "ElectronicPrescription" | translate }}</h5>
          <p>{{ "SaleElectronicPrescriptionDescription" | translate }}</p>
          <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#pricingModal" [routerLink]="['/ElectronicPrescription']">
            {{ "GoToSaleElectronic" | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="col-12 col-xxl-3 col-xl-6 col-md-6 mb-3 animate__animated animate__fadeInLeft animate__delay-2-8s">
      <div class="card">
        <div class="card-body text-center">
          <i class="mb-3 bx-md fa-solid fa-boxes-stacked"></i>
          <h5>{{ "Stock" | translate }}</h5>
          <p>{{ "StockDescription" | translate }}</p>
          <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#pricingModal" [routerLink]="['/Stock']">
            {{ "GoToStock" | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 mb-3 animate__animated animate__backInUp animate__delay-4-4s">
      <div class="card">
        
        <div
        class="card-header d-flex justify-content-between align-items-center p-2 danger-title"
      >
        <h6 class="card-title mb-0">
          {{ "InventoryExpire" | translate }}
        </h6>
        <h5 class="card-title mb-0">
            <i class="fa-solid fa-clock-rotate-left"></i>
        </h5>
      </div>
        <div class="card-body p-0 pt-1">
          <app-pctable [data]="dataExpire"> </app-pctable>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 mb-3 animate__animated animate__backInLeft animate__delay-4-8s"
    >
      <div class="card">
        <div
          class="card-header d-flex justify-content-between align-items-center p-2 danger-title"
        >
          <h6 class="card-title mb-0">
            {{ "needsBye" | translate }}
          </h6>
          <h5 class="card-title mb-0">
              <i class="fa-solid fa-battery-quarter"></i>
          </h5>
        </div>
        <div class="card-body p-0 pt-1">
          <app-pctable [data]="dataNeedToBy"> </app-pctable>
        </div>
      </div>
    </div>
  </div>
</div>
